/**
 * @description 菜单
 * @author xiehan
 * @date 2018/9/17
 */
import Logic from './logic-base'

const headerBiz = new Logic()

headerBiz.getUserInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.getSelfInfo,
    data: data
  })
}

headerBiz.updateUserInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.updateSelfInfo,
    data: data
  })
}

headerBiz.updatePassword = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.userManage.updatePassword,
    data: data
  })
}

export default headerBiz
